<template>
  <ContextColorProvider context="trade" class="splash">
    <div class="splash__container">
      <div>
        <BrandImage
          class="splash__logo"
          data-testid="logo"
          :image="EBrandImageLogos.SYMBOL_PRIMARY"
          width="32px"
          :schema="EBrandImageSchemas.POSITIVE"
          as="span"
        />

        <Heading class="splash__title">Custódia Remunerada</Heading>
      </div>
    </div>

    <img
      :src="bannerSplash"
      alt="Banner Splash Custódia Remunerada"
      class="splash__image"
      loading="eager"
      fetchpriority="high"
    />
  </ContextColorProvider>
</template>

<script setup lang="ts">
import {
  BrandImage,
  ContextColorProvider,
  EBrandImageLogos,
  EBrandImageSchemas,
  Heading
} from '@warrenbrasil/nebraska-web';

const bannerSplash =
  'https://warren.com.br/assets/trade/paid-custody/banner-splash.png';
</script>

<style scoped lang="less">
@keyframes fadeInUp {
  0% {
    transform: translateY(50vh);
  }

  30% {
    transform: translateY(0);
  }

  70% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(100vh);
  }
}

.splash {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 21;
  overflow: hidden;
  background: @background-secondary;

  animation: fadeInUp 1.8s ease-in-out forwards;

  &__container {
    max-width: 832px;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
    margin: 0 auto;
    padding-bottom: @size-spacing-x500;

    .to-md({ 
      padding: 0 @size-spacing-x400 @size-spacing-x1400 @size-spacing-x400 ; 
      flex-direction: column; 
      justify-content: center;
      gap: @size-spacing-x1000;
    });
  }

  &__logo {
    margin-bottom: @size-spacing-x600;
  }

  &__title {
    max-width: 366px;
  }

  &__image {
    width: 60vw;
    position: absolute;
    bottom: 0;
    right: 0;

    .to-md({ 
      width: 50%;
    });
  }
}
</style>
